import type { Template } from "@/types";

export const SQ_04_H0_V4: Template[] = [
    {
        id: "sq-04-h0v4-01",
        name: "SQ 01 - H0V4",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-04-h0_v4_01.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 0, y: 95, width: 353, height: 527, rotation: 0, imageRotation: 0 },
            { id: "2", x: 361, y: 95, width: 353, height: 527, rotation: 0, imageRotation: 0 },
            { id: "3", x: 722, y: 95, width: 352, height: 527, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1082, y: 95, width: 352, height: 527, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-04-h0v4-02",
        name: "SQ 02 - H0V4",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-04-h0_v4_02.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 56, y: 115, width: 325, height: 487, rotation: 0, imageRotation: 0 },
            { id: "2", x: 389, y: 115, width: 325, height: 487, rotation: 0, imageRotation: 0 },
            { id: "3", x: 722, y: 115, width: 325, height: 487, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1055, y: 115, width: 324, height: 487, rotation: 0, imageRotation: 0 }
        ],
    },


    {
        id: "sq-04-h0v4-03",
        name: "SQ 03 - H0V4",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-04-h0_v4_03.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "3", x: 41, y: 130, width: 314, height: 458, rotation: 0, imageRotation: 0 },
            { id: "4", x: 363, y: 130, width: 314, height: 458, rotation: 0, imageRotation: 0 },
            { id: "1", x: 758, y: 130, width: 314, height: 458, rotation: 0, imageRotation: 0 },
            { id: "2", x: 1080, y: 130, width: 314, height: 458, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-04-h0v4-04",
        name: "SQ 04 - H0V4",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-04-h0_v4_04.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 0, y: 0, width: 466, height: 717, rotation: 0, imageRotation: 0 },
            { id: "2", x: 510, y: 150, width: 286, height: 417, rotation: 0, imageRotation: 0 },
            { id: "3", x: 804, y: 150, width: 286, height: 417, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1098, y: 150, width: 286, height: 417, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-04-h0v4-05",
        name: "SQ 05 - H0V4",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-04-h0_v4_05.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 189, y: 363, width: 205, height: 305, rotation: 0, imageRotation: 0 },
            { id: "2", x: 189, y: 49, width: 205, height: 306, rotation: 0, imageRotation: 0 },
            { id: "3", x: 402, y: 49, width: 420, height: 619, rotation: 0, imageRotation: 0 },
            { id: "4", x: 830, y: 49, width: 420, height: 619, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-04-h0v4-06",
        name: "SQ 06 - H0V4",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-04-h0_v4_06.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 188, y: 51, width: 418, height: 615, rotation: 0, imageRotation: 0 },
            { id: "2", x: 615, y: 51, width: 204, height: 304, rotation: 0, imageRotation: 0 },
            { id: "3", x: 615, y: 363, width: 204, height: 304, rotation: 0, imageRotation: 0 },
            { id: "4", x: 828, y: 51, width: 418, height: 615, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-04-h0v4-07",
        name: "SQ 07 - H0V4",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-04-h0_v4_07.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 50, y: 49, width: 406, height: 619, rotation: 0, imageRotation: 0 },
            { id: "2", x: 464, y: 363, width: 205, height: 305, rotation: 0, imageRotation: 0 },
            { id: "3", x: 464, y: 49, width: 205, height: 305, rotation: 0, imageRotation: 0 },
            { id: "4", x: 866, y: 49, width: 420, height: 619, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-04-h0v4-08",
        name: "SQ 08 - H0V4",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-04-h0_v4_08.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 148, y: 49, width: 420, height: 619, rotation: 0, imageRotation: 0 },
            { id: "2", x: 767, y: 49, width: 404, height: 619, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1179, y: 49, width: 205, height: 306, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1179, y: 363, width: 205, height: 305, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-04-h0v4-09",
        name: "SQ 09 - H0V4",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-04-h0_v4_09.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 65, y: 146, width: 290, height: 425, rotation: 0, imageRotation: 0 },
            { id: "2", x: 363, y: 146, width: 290, height: 425, rotation: 0, imageRotation: 0 },
            { id: "3", x: 782, y: 146, width: 290, height: 425, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1080, y: 146, width: 290, height: 425, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-04-h0v4-10",
        name: "SQ 10 - H0V4",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-04-h0_v4_10.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 37, y: 148, width: 286, height: 421, rotation: 0, imageRotation: 0 },
            { id: "2", x: 346, y: 148, width: 286, height: 421, rotation: 0, imageRotation: 0 },
            { id: "3", x: 656, y: 148, width: 286, height: 421, rotation: 0, imageRotation: 0 },
            { id: "4", x: 969, y: 30, width: 435, height: 657, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-04-h0v4-11",
        name: "SQ 11 - H0V4",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-04-h0_v4_11.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 30, y: 33, width: 431, height: 651, rotation: 0, imageRotation: 0 },
            { id: "2", x: 576, y: 334, width: 238, height: 351, rotation: 0, imageRotation: 0 },
            { id: "3", x: 822, y: 334, width: 237, height: 351, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1067, y: 334, width: 237, height: 351, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-04-h0v4-12",
        name: "SQ 12 - H0V4",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-04-h0_v4_12.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 32, y: 33, width: 431, height: 651, rotation: 0, imageRotation: 0 },
            { id: "2", x: 577, y: 183, width: 237, height: 351, rotation: 0, imageRotation: 0 },
            { id: "3", x: 822, y: 183, width: 237, height: 351, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1067, y: 183, width: 237, height: 351, rotation: 0, imageRotation: 0 }
        ],
    },

];

